
//images
import adv1 from '~/images/expertise/advantages/adv1.png';
import adv2 from '~/images/expertise/advantages/adv2.png';
import adv3 from '~/images/expertise/advantages/adv3.png';
import adv4 from '~/images/expertise/advantages/adv4.png';

export const advantagesContent = [
  {
    key: 'adv1',
    image: adv1,
    title: "The Orthosnap Advantage",
    content: [
      {
        title: 'Not all clear aligners are created equal.',
        text: "The manufacturing process for 3D printed and CAD-based clear aligners causes inaccuracies due to optical discrepancies and resolution presets that undermine their effectiveness. Orthosnap remedies inaccuracies by using a dynamic physical model (DPM) of the patient’s teeth. Each tooth is separated on an independent pin, enabling the movement of individual teeth in a predetermined direction."
      }
    ]
  },
  {
    key: 'adv2',
    image: adv2,
    title: "Dynamic Physical Model",
    content: [
      {
        title: 'Orthosnap vs 3D Printing',
        text: 'The limitations of 3D printed aligners are self-evident and visible to the naked eye. CAD-based systems go from analog to digital and back to analog. With each conversion, there’s a decrease in accuracy.'
      },
      {
        title: 'The Opposite of Precise',
        text: 'The 3D printing process itself introduces inaccuracies since 3D printers print from the bottom up. In order to reproduce angled surfaces, they substitute steps or contour lines. In a multi-step process, this leads to compounded inaccuracies that undermine the performance of the aligners. \n'
      }
    ]
  },
  {
    key: 'adv3',
    image: adv3,
    title: "Technology at Orthosnap",
    content: [
      {
        title: 'Technology at Orthosnap',
        text: 'Orthosnap treatment begins with a PVS record impression from the patient’s teeth. Our proprietary manufacturing process produces precise fitting aligners with a superior level of accuracy and movement control  over 3D printed aligners. It also reduces costs by 30%, making Orthosnap a compelling alternative to other brands.'
      }
    ]
  },
  {
    key: 'adv4',
    image: adv4,
    title: "Pin & Sleeve System",
    content: [
      {
        title: 'Made to Move',
        text: 'The Dynamic Physical Model® is constructed so that each tooth to be moved rests on its own pin. This enables incremental movement of the affected tooth in isolation from the adjacent teeth, enabling full body movements vs. simply tilting the teeth.'
      }
    ]
  }
];
